module.exports = __webpack_public_path__ + "img/insulation.cd98df68.svg";